import dxButton from 'devextreme/ui/button'
import dxTabPanel from 'devextreme/ui/tab_panel'
import importTelas from '../telas/importTelas'
import ControleSessao from './ControleSessao'
import { PopUpPadrao } from './PopUpPadrao'

export default class ControleTabPadrao {
    classesIniciadas = {}
    tabPanelItems = [];
    idGlobal = 0;
    titleElements = [];
    /**
     *
     * @param {import('devextreme/ui/drawer').default} drawerInstance
     */
    constructor(drawerInstance) {
        this.render()

        this.drawerInstance = drawerInstance;
    }

    render() {
        this.renderTabPanel = this.tabPanel()
    }

    get tabPanelInstance() {
        return this.renderTabPanel.instance
    }

    tabPanel() {
        const content = $("#tabpanel-container")
        let instancia = this;

        const instance = new dxTabPanel(content, {
            height: window.innerHeight - 55,
            dataSource: [],
            selectedIndex: 0,
            loop: false,
            animationEnabled: true,
            swipeEnabled: false,
            hoverStateEnabled: false,
            repaintChangesOnly: true,
            showNavButtons: true,
            scrollByContent: true,
            scrollingEnabled: true,
            noDataText: "",
            tabIndex: undefined,
            deferRendering: false,
            itemTitleTemplate: (itemData, itemIndex, itemElement) => {
                const content = $(itemElement)
                const contentButton = $("<div class='close-tab'></div>");

                content.css('overflow', 'hidden');

                const titleTab = $("<span style='padding-right: 43px;'>" + itemData.nomeTela + "</span>");
                instancia.titleElements[itemIndex] = titleTab;
                titleTab.appendTo(content)
                new dxButton(contentButton, {
                    text: "x",
                    onClick: () => this.removeTab(itemData.ID)
                })

                contentButton.appendTo(content)
            },
            onSelectionChanged: ({ addedItems, removedItems }) => {
                if (!addedItems.length) return

                const actualTab = addedItems[0];
                const prevTab = removedItems.length ? removedItems[0] : null;

                if (this.getClasseIniciada(actualTab.classe.name, actualTab.ID)?.reloadGrid) {
                    this.getClasseIniciada(actualTab.classe.name, actualTab.ID).reloadGrid()
                }

                if (prevTab && this.getClasseIniciada(actualTab.classe.name, actualTab.ID)?.stopReload) {
                    this.getClasseIniciada(actualTab.classe.name, actualTab.ID).stopReload()
                }

                // //Altera URL e titulo da aba do navegador
                document.title = `${actualTab.nomeTela} - Logae`;
                ga(
                    'send',
                    'event',
                    'Troca_de_aba',
                    'change_tab',
                    `{
                        ID_USUARIO: ${ControleSessao.getIdUsuario()},
                        ID_EMPRESA: ${ControleSessao.getIdEmpresa()},
                        IDS_FILIAIS: ${ControleSessao.getFiliais().map((filial) => filial.CAB_RAZAO).join(',')},
                        DATA_HORA: ${new Date()},
                        ABA_ABERTA: ${actualTab.nomeTela}
                    }`
                );

                ga('send', 'pageview', `${window.location.pathname}${this.slugfy(actualTab.nomeTela)}`);
            },
            itemTemplate: async (itemData, itemIndex, itemElement) => {
                try {
                    const invokeClass = new itemData.classe

                    this.classesIniciadas[`${itemData.classe.name}_${itemData.ID}`] = invokeClass

                    if (invokeClass.setControleTab) {
                        invokeClass.setControleTab(this)
                    }

                    if (invokeClass.setElementId) {
                        invokeClass.setElementId(itemData.idRegistro)
                    }

                    if (invokeClass.setComponenteTab) {
                        invokeClass.setComponenteTab($(itemElement));
                    }

                    if (Object.getPrototypeOf(itemData.classe) == PopUpPadrao) {
                        this.removeTab(itemData.ID)
                        invokeClass.getRender().appendTo($('.raster-app'));
                        invokeClass.getDxPopUp().show();
                        return
                    }

                    $(itemElement).css("overflow", "auto");

                    const doRender = invokeClass.getRender();

                    if (doRender instanceof Promise) {
                        const firstRender = await doRender

                        $(itemElement).append(firstRender)
                    } else {
                        $(itemElement).append(doRender)
                    }

                    if (invokeClass.callbackAfterRender) {
                        const callbackAfterRender = invokeClass.callbackAfterRender(itemElement);

                        if (callbackAfterRender instanceof Promise) {
                            await callbackAfterRender
                        } else {
                            callbackAfterRender
                        }
                    }
                } catch (err) {
                    console.error(err);
                    var msg = $('<div><b><center>' + err + '</center></b></div>');
                    msg.appendTo(itemElement);
                }
            }
        });

        return {
            content,
            instance
        }
    }

    async incluiTab(titleTab, classe, idRegistro = {}) {
        try {
            const classContent = await importTelas[classe];

            this.tabPanelItems.push({
                ID: this.idGlobal,
                nomeTela: titleTab ?? 'Aba sem título',
                idRegistro: idRegistro,
                classe: classContent[classe]
            });

            const tabItens = this.tabPanelItems;

            this.tabPanelInstance.option("dataSource", tabItens);
            this.tabPanelInstance.option("selectedIndex", tabItens.length - 1);

            this.drawerInstance.toggle();

            this.idGlobal++;
        } catch (e) {
            console.log(e)
        }
    }

    removeTab(tabId) {
        const findTabindex = this.tabPanelItems.findIndex((tab) => tab.ID == tabId)

        if (findTabindex == -1) return;

        const actualTab = this.tabPanelItems[findTabindex]

        this.getClasseIniciada(actualTab.classe.name, actualTab.ID).destroy()

        this.tabPanelItems.splice(findTabindex, 1);

        this.tabPanelInstance.option("items", this.tabPanelItems);

        if (!this.tabPanelItems.length) this.tabPanelInstance.option("selectedIndex", -1);
    }

    slugfy(str) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
        var to = "aaaaaeeeeeiiiiooooouuuunc------";
        for (var i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes

        return str;
    };

    get instance() {
        return this.renderTabPanel.instance
    }

    setTabName(nome) {
        let elemento = $(this.titleElements[this.tabPanelInstance.option("selectedIndex")]);
        $(elemento).text(nome);
    }

    getClasseIniciada(classeName, tabId) {
        return this.classesIniciadas[`${classeName}_${tabId}`]
    }
}
